import { useMemo } from 'react';
import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useRankingsChartsDataContext } from './hooks/useRankingsChartsDataContext';

export const ByCity = () => {
    const { chartData } = useRankingsChartsDataContext();

    const { subtitles, values } = useMemo(() => {
        const items = (chartData?.byCity || [])
            .slice()
            .sort((a, b) => Number(b?.total || 0) - Number(a?.total || 0))
            .slice(0, 10);

        return {
            subtitles: items.map((item) => item?.nome_municipio || 'Não informado'),
            values: items.map((item) => Number(item?.total || 0))
        };
    }, [chartData]);

    return (
        <SimpleBars
            title="Ranking por Cidade"
            horizontal={true}
            subtitles={subtitles}
            values={values}
            height={420}
            showDataLabels={true}
        />
    );
};
